<template>
  <a-modal
    title="预览视频"
    :visible="visible"
    :maskClosable="false"
    :footer="name ? undefined : null"
    @ok="handleCancel"
    @cancel="handleCancel"
  >
    <div class="preview-content">
      <video
        autoplay
        controls
        v-if="url"
        :src="$pub.CDN_URL(url)"
      ></video>
    </div>
    <template #footer v-if="name">
      <a-button type="primary" :loading="isDownloading" :disabled="isDownloading" @click="handleDownload">下载</a-button>
    </template>
  </a-modal>
</template>

<script>
import { DOWLOAD_FILE_URL_PRO } from '@/utils/download'

export default {
  data () {
    return {
      // 是否展示
      visible: false,
      // 视频地址
      url: undefined,
      // 短剧名称（传入时才显示下载按钮）
      name: undefined,
      // 下载中
      isDownloading: false
    }
  },
  methods: {
    // 显示
    showModal (url, name) {
      this.url = url
      this.name = name || undefined
      this.visible = true
    },
    // 关闭
    handleCancel () {
      // 延迟清空
      setTimeout(() => {
        this.url = undefined
        this.name = undefined
      }, 200)
      // 隐藏
      this.visible = false
    },
    // 下载
    async handleDownload () {
      if (!this.url) return
      const fullUrl = this.$pub.CDN_URL(this.url)
      const ext = (fullUrl.match(/\.(\w+)(?:\?|$)/) || [])[1] || 'mp4'
      const filename = `${this.name}.${ext}`
      this.isDownloading = true
      try {
        await DOWLOAD_FILE_URL_PRO(fullUrl, filename)
      } catch {
        // 下载失败静默处理
      } finally {
        this.isDownloading = false
      }
    }
  }
}
</script>

<style scoped>
.preview-content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.preview-content video {
  width: 100%;
  height: 100%;
  max-width: 500px;
  max-height: 500px;
}
</style>
